import { useState } from "react";
import { Download, Loader2, Presentation, UserRound } from "lucide-react";
import { toast } from "sonner";
import { API, api, errMsg } from "@/lib/api";
import { downloadAsset } from "@/components/marketing/AssetImage";

const DECKS = [
  ["sales", "Sales Deck", "15 slides: quiénes somos, cómo funciona, los 5 servicios, tecnología, red y contacto. Para clientes personas y empresas."],
  ["franquicias", "Deck de franquicias y asesores", "15 slides: oportunidad, modelo de ingresos, planes, ROI, qué incluye, territorios y proceso. Para reclutar asesores y franquiciatarios."],
];

export const DeckSection = ({ owner, onCreated }) => {
  const [busy, setBusy] = useState(null);
  const generate = async (kind) => {
    setBusy(kind);
    try {
      const { data } = await api.post("/marketing/deck", { kind, personalized: true });
      toast.success("Deck personalizado listo");
      onCreated?.(data);
      downloadAsset(data.url, data.filename);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <section className="space-y-4" data-testid="mkt-decks">
      <div><p className="eyebrow">Decks para presentar</p><h2 className="font-display font-bold text-lg">Presentaciones PDF con ligas clicables</h2><p className="text-sm text-[#575757] mt-1 max-w-2xl">Descarga la versión corporativa o genera tu deck con tu nombre, WhatsApp y tu liga con atribución en la portada y el cierre; todas las ligas del PDF llevan tu <code>ref</code>.</p></div>
      <div className="grid md:grid-cols-2 gap-4">
        {DECKS.map(([kind, title, desc]) => (
          <div key={kind} data-testid={`deck-card-${kind}`} className="rounded-2xl border border-black/[.06] bg-white p-5 flex flex-col gap-3 card-lift">
            <div className="flex items-center gap-3"><span className="h-11 w-11 rounded-2xl bg-[#FFF6EC] text-[#FF7A00] grid place-items-center shrink-0"><Presentation size={22} /></span><div><div className="font-display font-bold" data-testid={`deck-title-${kind}`}>{title}</div><div className="text-[11px] text-[#8A8A8A]">PDF 16:9 · 15 slides · ligas a fiinbridge.com</div></div></div>
            <p className="text-sm text-[#575757] flex-1">{desc}</p>
            <div className="flex flex-wrap gap-2">
              <button type="button" data-testid={`deck-personal-${kind}`} disabled={!!busy} onClick={() => generate(kind)} className="btn-brand !py-2 !px-3 text-sm">{busy === kind ? <Loader2 size={14} className="animate-spin" /> : <UserRound size={14} />} Generar con mis datos</button>
              <a data-testid={`deck-corporate-${kind}`} href={`${API}/public/deck/${kind}`} target="_blank" rel="noreferrer" className="btn-outline !py-2 !px-3 text-sm"><Download size={14} /> Versión corporativa</a>
            </div>
            <p className="text-[11px] text-[#8A8A8A]">Con tus datos: <b>{owner.name}</b>{owner.phone ? ` · WhatsApp ${owner.phone}` : " · sin WhatsApp (edítalo en Mi página)"} · {owner.link}</p>
          </div>))}
      </div>
    </section>
  );
};
